import { Stack, SvgIconProps, Typography } from '@mui/material';
import { ElementType } from 'react';

/** Card section header with a leading themed icon, as used across the Hostess Auto Reply pages. */
const SettingsSectionHeader = (props: { icon: ElementType<SvgIconProps>; title: string }) => {
    const { icon: Icon, title } = props;

    return (
        <Stack direction="row" spacing={1.25} alignItems="center" sx={{ mb: 2 }}>
            <Icon sx={{ color: 'primary.main' }} />
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {title}
            </Typography>
        </Stack>
    );
};

export default SettingsSectionHeader;
